import React from "react";
import { Link } from "react-router-dom";
import KazemLogo from "@/components/KazemLogo";
import { Mail, Linkedin } from "lucide-react";
import { CONTACT_EMAIL, SERVICES } from "@/lib/siteData";
import { useLang } from "@/context/LangContext";

export default function PublicFooter() {
    const { t } = useLang();
    const about = [
        { to: "/a-propos", label: t("Notre entreprise", "Our company") },
        { to: "/engagement", label: t("Notre engagement", "Our commitment") },
        { to: "/actualites", label: t("Actualités", "News") },
        { to: "/suivi", label: t("Suivi d'expédition", "Shipment tracking") },
        { to: "/devis", label: t("Demande de devis", "Quote request") },
    ];
    return (
        <footer className="bg-[#0b2545] text-blue-100/80" data-testid="public-footer">
            <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.3fr_1.2fr_1fr_1.3fr_0.6fr]">
                <div>
                    <KazemLogo light size="lg" />
                    <p className="mt-5 text-sm">{t("Plus qu'un transport, une solution.", "More than transport, a solution.")}</p>
                </div>
                <FooterCol title={t("Nos services", "Our services")}>
                    {SERVICES.map((s) => (
                        <li key={s.slug}><Link to={`/services#${s.slug}`} className="hover:text-[#f26b1d]">{t(s.title, s.titleEn)}</Link></li>
                    ))}
                </FooterCol>
                <FooterCol title={t("À propos", "About")}>
                    {about.map((a) => (
                        <li key={a.to}><Link to={a.to} className="hover:text-[#f26b1d]">{a.label}</Link></li>
                    ))}
                </FooterCol>
                <FooterCol title="Contact">
                    <li>
                        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-[#f26b1d]">
                            <Mail size={17} className="text-[#f26b1d]" /> {CONTACT_EMAIL}
                        </a>
                    </li>
                </FooterCol>
                <FooterCol title={t("Suivez-nous", "Follow us")}>
                    <li><span className="inline-flex w-8 h-8 items-center justify-center rounded bg-slate-50 text-[#0b2545]" data-testid="footer-linkedin"><Linkedin size={17} /></span></li>
                </FooterCol>
            </div>
            <div className="border-t border-blue-100/10">
                <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs">
                    <div>© {new Date().getFullYear()} Kazem Logistics. {t("Tous droits réservés.", "All rights reserved.")}</div>
                    <div className="flex gap-5">
                        <span>{t("Mentions légales", "Legal notice")}</span><span>{t("Politique de confidentialité", "Privacy policy")}</span><span>Cookies</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

function FooterCol({ title, children }) {
    return (
        <div>
            <div className="font-semibold text-slate-50 text-sm mb-4">{title}</div>
            <ul className="space-y-2 text-[13px]">{children}</ul>
        </div>
    );
}
